function set(route, query) {
	return { ...route, query }
}

function remove(route, key) {
	const query = { ...route.query }
	delete query[key]
	return { ...route, query }
}

function update(route, key, value) {
	return {
		...route,
		query: {
			...route.query,
			[key]: value
		}
	}
}

function roll(route) {
	const qs = Object.entries(route.query)
		.filter(([, v]) => v !== undefined)
		.map(e => e.join('='))
		.join('&')
	return qs ? `?${qs}` : ''
}

function sort(route, column, dir) {
	const sort = `${column}:${dir}`
	return update(route, '_sort', sort)
}

export default {
	set,
	remove,
	update,
	sort,
	roll
}
